module.exports = __webpack_public_path__ + "static/media/aso-times.0fdd8545.png";